import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import { toast } from 'sonner';
import PasswordInput from '@/components/PasswordInput';

const BACKEND_URL = '';

export default function ChangePasswordSection() {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [loading, setLoading] = useState(false);
  const token = sessionStorage.getItem('session_token');
  const headers = { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };

  const handleChange = async () => {
    if (!currentPw || !newPw) { toast.error('Please fill in all fields'); return; }
    if (newPw.length < 6) { toast.error('New password must be at least 6 characters'); return; }
    if (newPw !== confirmPw) { toast.error('New passwords do not match'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/change-password`, {
        method: 'POST', credentials: 'include', headers,
        body: JSON.stringify({ current_password: currentPw, new_password: newPw }),
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.detail || 'Failed'); }
      toast.success('Password updated successfully');
      setCurrentPw(''); setNewPw(''); setConfirmPw('');
    } catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  return (
    <Card className="p-6 border border-slate-200 mt-4" data-testid="change-password-section">
      <h3 className="text-sm font-bold font-heading mb-4 text-slate-500 uppercase tracking-wide flex items-center gap-2">
        <Lock className="h-4 w-4" /> Change Password
      </h3>
      <div className="space-y-3 max-w-sm">
        <PasswordInput data-testid="current-password-input" placeholder="Current password"
          value={currentPw} onChange={e => setCurrentPw(e.target.value)} className="h-10 border-slate-200 pr-10" />
        <PasswordInput data-testid="new-password-input" placeholder="New password"
          value={newPw} onChange={e => setNewPw(e.target.value)} className="h-10 border-slate-200 pr-10" />
        <PasswordInput data-testid="confirm-password-input" placeholder="Confirm new password"
          value={confirmPw} onChange={e => setConfirmPw(e.target.value)} className="h-10 border-slate-200 pr-10" />
        <Button data-testid="change-password-btn" onClick={handleChange} disabled={loading}
          size="sm" className="bg-brand-navy hover:bg-brand-dark text-white">
          {loading ? 'Updating...' : 'Update Password'}
        </Button>
      </div>
    </Card>
  );
}
